import React from 'react'

import T from 'components/FormattedMessage'

import { PlayerPositionNameToken, PlayerPositionCodeToken } from 'lib/enumTranslations'
import { PlayerPosition as PlayerPositionEnum } from 'protos'

type Props = {
  position: PlayerPositionEnum | undefined | null
  variant?: 'normal' | 'short'
}

const PlayerPosition = ({ position, variant }: Props) => (
  position
    ? (
      <T id={(variant === 'normal' ? PlayerPositionNameToken : PlayerPositionCodeToken)(position)} />
    ) : null
)

export default PlayerPosition
try {
    // @ts-ignore
    PlayerPosition.displayName = "PlayerPosition";
    // @ts-ignore
    PlayerPosition.__docgenInfo = { "description": "", "displayName": "PlayerPosition", "props": { "position": { "defaultValue": null, "description": "", "name": "position", "required": true, "type": { "name": "any" } }, "variant": { "defaultValue": null, "description": "", "name": "variant", "required": false, "type": { "name": "\"normal\" | \"short\"" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerPosition/PlayerPosition.tsx#PlayerPosition"] = { docgenInfo: PlayerPosition.__docgenInfo, name: "PlayerPosition", path: "src/components/PlayerPosition/PlayerPosition.tsx#PlayerPosition" };
}
catch (__react_docgen_typescript_loader_error) { }